// *******************************************************************************
// Mobile toggles
// *******************************************************************************

const searchInput = document.querySelector('.header-search__input-field');
const searchForm = document.querySelector('[data-search-form]');
const loginDropdown = document.querySelector('.login-dropdown__list.level-1');

const toggleMenuClass = (toggle) => document.body.classList.toggle('is-open-menu', toggle);

const toggleSearchClass = (toggle) => {
  document.body.classList.toggle('is-open-search', toggle);

  if (toggle) {
    searchInput.focus();
    return;
  }

  searchInput.blur();
  searchForm.reset();
};

const toggleLoginDropdown = (toggle) => {
  if (windowWidth() < breakpointMd) {
    document.body.classList.toggle('is-open-login', toggle);
    slideToggle(loginDropdown, 300, 'block');
  }
};

const closeOtherToggles = (exclude) => {
  if (exclude !== 'menu') toggleMenuClass(false);
  if (exclude !== 'search') toggleSearchClass(false);
};

attachEvent('.hamburger', 'click', () => {
  closeOtherToggles('menu');
  toggleMenuClass(!document.body.classList.contains('is-open-menu'));
});

// ---
// Login Toggle
// ---

attachEvent('.login-dropdown__placeholder', 'click', () => {
  closeOtherToggles('login');
  toggleLoginDropdown(!document.body.classList.contains('is-open-login'));
});

attachEvent('.login-dropdown__overlay', 'click', () => {
  toggleLoginDropdown(false);
});

// ---
// Search Toggle
// ---
attachEvent('.site-header__search-btn', 'click', () => {
  toggleSearchClass(!document.body.classList.contains('is-open-search'));
  closeOtherToggles('search');
});

attachEvent('[data-close-search]', 'click', () => {
  toggleSearchClass(false);
  searchInput.value = '';
});

// event listener for ESC key
if (searchInput && searchForm) {
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      const isFocused = document.activeElement === searchInput;
      if (!isFocused) {
        toggleSearchClass(false);
        toggleBodyScrollLock(false);
        searchInput.value = '';
      }
    }
  });
}

// *******************************************************************************
// Add class to body after some scroll
// *******************************************************************************
function addScrollingClass() {
  const topOffset = document.documentElement.scrollTop || document.body.scrollTop;
  document.body.classList.toggle('is-scrolled', topOffset > 30);
}

addScrollingClass();

let ticking = false;
document.addEventListener('scroll', () => {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      addScrollingClass();
      ticking = false;
    });
    ticking = true;
  }
});

let lastScrollTop = 0;
window.addEventListener(
  'scroll',
  () => {
    const isScrolledTop = window.pageYOffset || document.documentElement.scrollTop;
    document.body.classList.toggle('is-scrolled-up', isScrolledTop < lastScrollTop);
    lastScrollTop = isScrolledTop <= 0 ? 0 : isScrolledTop;
  },
  false,
);
